import PropTypes from 'prop-types'
import React from 'react'
import Router from 'next/router'
import { connect } from 'react-redux'
import clsx from 'clsx'
import CategoryTabList from 'components/category/category-tab-list'
import ResponsiveImage from 'components/images/responsive-image'
import Typo from 'constants/typography'
import { withI18next } from 'lib/i18n/withI18next'
import StateStorage from 'lib/state-storage'
import {
  CATEGORY_BANNER_WITH_LINK,
  CATEGORY_BANNER_WITH_TNC,
  CATEGORY_TAB_IDS,
  CATEGORY_TAB_IDS_2,
} from 'pages/category/const'
import BackdropModal from 'components/portal/backdrop-modal'
import TncModal from 'components/modal/tnc-modal'
import styles from './styles.scss'

const ENABLE_BANNER_TABLIST = true

class CategoryHeader extends React.Component {
  static SHOP_NAME = StateStorage.getShop()

  static LANGUAGE_NAME = StateStorage.getLanguage()

  static CURSOR_POINTER_STYLE = { cursor: 'pointer' }

  state = {
    tncModalData: null,
  }

  isSpecialCategory() {
    const { categoryId } = this.props

    return (
      CATEGORY_TAB_IDS.includes(categoryId) ||
      CATEGORY_TAB_IDS_2.includes(categoryId)
    )
  }

  getCategoryLink() {
    const { categoryId } = this.props

    return CATEGORY_BANNER_WITH_LINK.find((cat) => cat.id === categoryId)
  }

  onBannerClicked = () => {
    const { categoryId } = this.props
    const hasTnc = CATEGORY_BANNER_WITH_TNC.includes(categoryId)

    if (hasTnc) {
      this.setState({ tncModalData: 'category-tnc-1' })
      return
    }

    const link = this.getCategoryLink()

    if (link) {
      const shop = StateStorage.getShop()
      const lang = StateStorage.getLanguage()

      Router.push(link.href, `/${shop}/${lang}${link.as}`)
    }
  }

  clearTncModalData = () => {
    this.setState({ tncModalData: null })
  }

  renderBanner = () => {
    const {
      categoryBanner,
      categoryId,
      isNewCategoryFiltersAndSort,
      isPhone,
      t,
      title,
    } = this.props
    const hasTnc = CATEGORY_BANNER_WITH_TNC.includes(categoryId)
    const customText = categoryBanner?.web_custom_text
    const customTextMobile = categoryBanner?.web_mobile_custom_text
    const caption = isPhone ? customTextMobile : customText

    return (
      <div className={clsx('category-header')}>
        <div
          className={clsx({
            'banner-new-design': isNewCategoryFiltersAndSort,
          })}
        >
          <ResponsiveImage
            alt={t(title)}
            imgRatio={isPhone ? 1.78 : 3.13}
            onClick={this.onBannerClicked}
            src={isPhone ? categoryBanner.web_mobile : categoryBanner.web}
            style={
              !isPhone && (this.getCategoryLink() || hasTnc)
                ? CategoryHeader.CURSOR_POINTER_STYLE
                : null
            }
          />
          {!!caption && (
            <span className={clsx('banner-new-design__artifacts')}>
              <span
                dangerouslySetInnerHTML={{ __html: caption }} // eslint-disable-line react/no-danger
              />
            </span>
          )}
        </div>
        {isNewCategoryFiltersAndSort && this.renderTitle()}
      </div>
    )
  }

  renderTitle = () => {
    const { isPhone, isNewCategoryFiltersAndSort, title } = this.props
    return (
      <div
        className={clsx(
          isPhone ? Typo.title3 : Typo.title2,
          'category-header__title-text',
          { 'new-design': isNewCategoryFiltersAndSort },
        )}
      >
        {title}
      </div>
    )
  }

  render() {
    const { categoryBanner, categoryId, isPhone, setPageOne } = this.props
    const { tncModalData } = this.state
    const hasBanner =
      (isPhone && categoryBanner?.web_mobile) ||
      (!isPhone && categoryBanner?.web)
    const isSpecialCategory = this.isSpecialCategory()

    return (
      <React.Fragment>
        <style jsx>{styles}</style>
        <React.Fragment>
          {hasBanner ? this.renderBanner() : this.renderTitle()}
          <BackdropModal
            freezeBody={isPhone}
            isOpen={!!tncModalData}
            onBackdropClick={this.clearTncModalData}
          >
            <TncModal data={tncModalData} close={this.clearTncModalData} />
          </BackdropModal>
        </React.Fragment>

        {isSpecialCategory && ENABLE_BANNER_TABLIST && (
          <CategoryTabList categoryID={categoryId} setPageOne={setPageOne} />
        )}
      </React.Fragment>
    )
  }
}

CategoryHeader.defaultProps = {
  categoryBanner: {},
  isNewCategoryFiltersAndSort: false,
}

CategoryHeader.propTypes = {
  categoryBanner: PropTypes.shape({
    web: PropTypes.string,
    web_mobile: PropTypes.string,
    web_custom_text: PropTypes.shape({}),
    web_mobile_custom_text: PropTypes.shape({}),
  }),
  categoryId: PropTypes.number.isRequired,
  isNewCategoryFiltersAndSort: PropTypes.bool,
  isPhone: PropTypes.bool.isRequired,
  setPageOne: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
}

const Extended = withI18next()(CategoryHeader)

export { CategoryHeader }

export default connect((state) => ({ isPhone: state.device.isPhone }))(Extended)
